import { ActionTypes } from "../constants/actionTypes";
export const setSidePanelopen = (status) => {
  return {
    type: ActionTypes.SET_SIDE_PANEL_STATUS,
    payload: status,
  };
};
export const setSidePanelResultType = (type) => {
  return {
    type: ActionTypes.SET_SIDE_PANEL_RESULT_TYPE,
    payload: type,
  };
};
export const setSidePanelStatusAndResultType = (status, type) => {
  return {
    type: ActionTypes.SET_SIDE_PANEL_STATUS_AND_TYPE,
    payload: { status: status, type: type },
  };
};
